
import { computed, defineComponent, onMounted, onServerPrefetch, ref, watch } from 'vue';

// Счетчик который рендерит цифру с нуля до определенного значения
export default defineComponent({
  name: 'DigitCounter',
  props: {
    // До куда считать
    count: {
      required: true,
      type: Number,
      default: 0,
    },
    // Количество милисекунд
    delay: {
      required: false,
      type: Number,
      default: 1000,
    },
    // Интервал в мс
    speed: {
      required: false,
      type: Number,
      default: 10,
    },
    // Точность
    precision: {
      required: false,
      type: Number,
      default: 0,
    },
    isSsr: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const intermediateValue = ref(0);

    const finishValue = computed(() => {
      return props.count;
    });

    const rendererValue = computed(() => {
      return intermediateValue.value.toFixed(props.precision);
    });

    function startCounter() {
      const ticks = props.delay / props.speed;
      const countInTick = finishValue.value / ticks;

      const interval = setInterval(() => {
        intermediateValue.value += countInTick;
        if (intermediateValue.value >= finishValue.value) {
          intermediateValue.value = Number(finishValue.value);
          clearInterval(interval);
        }
      }, props.speed);
    }

    function rerender() {
      startCounter();
    }

    watch(
      () => props.count,
      (newVal) => {
        if (newVal) {
          rerender();
        }
      }
    );

    onMounted(() => {
      rerender();
    });
    return { rendererValue };
  },
});
